export const isPresent = <T>(x: T): x is Exclude<T, undefined | null> =>
  x != null;

export const isArray = <T>(v: T): v is Extract<T, readonly unknown[]> =>
  Array.isArray(v);

export const isString = <T>(v: T): v is Extract<T, readonly unknown[]> =>
  typeof v === 'string';
